export default __webpack_public_path__ + "static/media/noTaskSchedule.a1844862.svg";